<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">Conductor</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Agregar
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.nombres" :error="form.errors.nombres" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombres" required/>
          <text-input v-model="form.apellidos" :error="form.errors.apellidos" class="pr-6 pb-8 w-full lg:w-1/2" label="Apellidos" required/>
          <text-input v-model="form.direccion" :error="form.errors.direccion" class="pr-6 pb-8 w-full lg:w-1/1" label="Dirección" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/3" label="E-mail" />
          <text-input v-model="form.telefono" :error="form.errors.telefono" class="pr-6 pb-8 w-full lg:w-1/3" label="Teléfono" />
          <text-input v-model="form.valor_hora_extra" :error="form.errors.valor_hora_extra" class="pr-6 pb-8 w-full lg:w-1/3" label="V. hora extra" />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Agregar Conductor</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Add Conductor' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombres: null,
        apellidos: null,
        organization_id: null,
        direccion: null,
        email: null,
        telefono: null,
        estado: 1,
        valor_hora_extra: null,
     
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('contacts.store'))
    },
  },
}
</script>
